import React from 'react';
import { X } from 'lucide-react';
import PCECard from './PCECard';

const PCEDetailModal = ({ pce, onClose, onViewConsumption }) => {
    if (!pce) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50">
            <div className="relative max-w-md w-full">
                <PCECard
                    pce={pce}
                    onViewConsumption={onViewConsumption}
                />
                <button
                    onClick={onClose}
                    className="absolute -top-4 -right-4 bg-white rounded-full p-2 shadow-lg text-gray-600 hover:text-red-500 hover:scale-110 transition-all"
                >
                    <X size={20} />
                </button>
            </div>
        </div>
    );
};

export default PCEDetailModal;
